import { getCoach } from "../../api/coach";
import store from "@/store";

const getDefaultState = () => {
    return { all: {} };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getCoach({ commit }, contractId) {
        // Commented out, because the coach card has a skeleton
        // if (!(contractId in state.all)) {
        //     commit("setLoading", true, { root: true });
        // }
        getCoach(contractId)
            .then((response) => {
                if (response.data.Status === 200) {
                    commit("setCoach", {
                        contractId: contractId,
                        coach: response.data.Result,
                    });
                } else {
                    store.cache.delete("coaches/getCoach", contractId);
                }
            })
            .catch(() => {
                store.cache.delete("coaches/getCoach", contractId);
            });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setCoach(state, payload) {
        state.all = { ...state.all, [payload.contractId]: payload.coach };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
